function universalToggleTarget() {
    var target = null;

    try {
        target = new URL(window.location.href);
    } catch (e) {
        target = null;
    }

    if (!target || target.pathname.indexOf('/catalog/browse') === -1) {
        var fallback = $('#toggle-universal-redirect').val();
        if (!fallback) {
            return target;
        }
        try {
            target = new URL(fallback, window.location.origin);
        } catch (e) {
            return null;
        }
    }


    target.pathname = target.pathname.replace(/\/\d+\/?$/, '/1/');

    return target;
}

export function initUniversalToggle() {
    $(document)
        .off('change.universalToggle', '.toggle-universal')
        .on('change.universalToggle', '.toggle-universal', function () {
            var checked = $(this).is(':checked') ? '1' : '0';
            var target = universalToggleTarget();

            if (!target) {
                return;
            }

            target.searchParams.set('universal', checked);

            var $auInput = $('#au');

            if ($auInput.length && target.searchParams.has('au')) {
                target.searchParams.set('au', $auInput.val());
            }

            var url = target.toString();

            if ($('.browse-shell').length) {
                import('../partials/browse.js')
                    .then(function (browse) {
                        browse.updateBrowseShell(
                            browse.normalizeBrowseResultsQueryParam(url),
                            true
                        );
                    })
                    .catch(function () {
                        window.location.href = url;
                    });
                return;
            }

            window.location.href = url;
        });
}

export function toggleVisibility(target) {
    var $element = $(target);
    var visible = $element.attr('data-toggle-visibility') === '1';
    $element.attr('data-toggle-visibility', visible ? '0' : '1');
}

export function initToggleDependentController() {
    $('.toggle-dependent-controller').on('change', function (e) {
        var $self = $(e.target);
        var dep_container_class = $self.attr('toggle-dependent-containers');
        if (!$self.is(':checked')) {
            $('.' + dep_container_class + ' :input:checkbox').prop(
                'checked',
                false
            );
            $('.' + dep_container_class + ' :input:text').val('');
            $('.' + dep_container_class).addClass('d-none');
        } else {
            $('.' + dep_container_class).removeClass('d-none');
        }
    });
}
